import { DELETE, GET, PATCH, POST } from "./Adapter/base";

export const getPackagingList = () => {
  return GET(`packagings/list`);
};
